interface CampaignShopCellProps {
  shopName: string | null;
}

export function CampaignShopCell({ shopName }: CampaignShopCellProps) {
  return (
    <span className="min-w-0 truncate text-ink" title={shopName ?? undefined}>
      {shopName ?? "—"}
    </span>
  );
}
